/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import React, { createContext, useContext } from "react";
import { showToast } from "./service";

/**
 * Toast context for backward compatibility
 * All notifications are now routed through Redux (see service.js)
 * Components should prefer useSnackbar hook from hooks/use-snackbar.hook.js
 */
const ToastContext = createContext({ showToast });

export const useToast = () => useContext(ToastContext);

/**
 * ToastProvider - simplified wrapper for backward compatibility
 * Notifications are now handled by Redux snackbar system
 * The actual UI rendering is done by components/ui/snackbar/snackbar.jsx
 */
export const ToastProvider = ({ children }) => {
  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  );
};
